import PitchAsMessage from './PitchAsMessage';

export default PitchAsMessage;
